import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-clinease-button',
  standalone: true,
  templateUrl: './clinease-button.component.html',
  styleUrls: ['./clinease-button.component.scss'],
  imports: [MatButtonModule],
})
export class ClineaseButtonComponent {
  @Input() text: string = '';
  @Input() disabled: boolean = false;
  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
